import { IStudentTableItemForStudentCode, Student } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'

const Layout = () => import('../views/Layout.vue')
const SchoolManage = () => import('../views/SchoolManage.vue')
const GradeList = () => import('../views/GradeList.vue')
const ClazzList = () => import('../views/ClazzListPage.vue')
const StudentList = () => import('../views/StudentList.vue')
const StudentAuth = () => import('../views/StudentAuth.vue')
const StudentAuthForAccount = () => import('../views/StudentAuthForAccount.vue')
const StudentAuthForAccountDetail = () => import('../views/StudentAuthForAccountDetail.vue')

const StudentListManagePage = () => import('../views/StudentListPage.vue')
const GradeDetails = () => import('../views/GradeDetails.vue')
const ClazzDetails = () => import('../views/ClazzDetailsPage.vue')
const ClazzDetailsForStudentCode = () => import('../views/ClazzDetailsForStudentCode.vue')

const StudentDetails = () => import('../views/StudentDetails.vue')
const StudentDetailsSchoolRollNo = () => import('../views/StudentDetailsForSchoolRollNo.vue')
const StudentDetailsForSchoolAccount = () => import('../views/StudentDetailsForSchoolAccount.vue')
const StudentMatchesInfo = () => import('../views/StudentMatchesInfo.vue')
const TeacherList = () => import('../views/TeacherList.vue')
const TeacherCreate = () => import('../views/TeacherCreate.vue')
const TeacherDetail = () => import('../views/TeacherDetail.vue')
export const schoolManageRoute: RouteConfig = {
  path: 'school-manage',
  name: 'school_manage',
  component: SchoolManage,
  meta: {
    title: '学校管理',
    showMenu: true,
    roles: ['verified'],
  },
}

export const gradeListRoute: RouteConfig = {
  path: 'grade-list',
  name: 'grade_list',
  component: GradeList,
  meta: {
    title: '年级管理',
    showMenu: false,
  },
}

export const clazzListRoute: RouteConfig = {
  path: 'clazz-list',
  name: 'clazz_list',
  component: ClazzList,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeNo: route.query.gradeNo ? Number(route.query.gradeNo) : null,
  }),
  meta: {
    title: '班级管理',
    showMenu: true,
  },
}

export const studentListRoute: RouteConfig = {
  path: 'student-list',
  name: 'student_list',
  component: StudentList,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '学生管理',
    showMenu: true,
  },
}

export const studentAuthRoute: RouteConfig = {
  path: 'student-auth',
  name: 'student_auth',
  component: StudentAuth,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '学生认证管理',
    showMenu: true,
    roles: ['verified'],
  },
}

export const studentAuthAccountRoute: RouteConfig = {
  path: 'student-auth-for-account',
  name: 'student_auth_for_account',
  component: StudentAuthForAccount,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '合作账号管理',
    showMenu: true,
    roles: ['userAccount'],
  },
}

export const studentAuthAccountDetailRoute: RouteConfig = {
  path: 'student-auth-for-account-detail',
  name: 'student_auth_for_account_detail',
  component: StudentAuthForAccountDetail,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '合作账号管理',
    roles: ['verified'],
  },
}

export const studentManageListRoute: RouteConfig = {
  path: 'student-manage-list',
  name: 'student_manage_list',
  component: StudentListManagePage,
  meta: {
    title: '学生名单',
    showMenu: true,
  },
}

export const gradeDetailsRoute: RouteConfig = {
  path: 'grade-details',
  name: 'grade_details',
  component: GradeDetails,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeId: Number(route.query.gradeId),
  }),
  meta: {
    title: '年级管理',
  },
}

export const clazzDetailsRoute: RouteConfig = {
  path: 'clazz-details',
  name: 'clazz_details',
  component: ClazzDetails,
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: Number(route.query.clazzId),
  }),
  meta: {
    title: '班级管理',
  },
}

export const clazzDetailsForStudentCodeRoute: RouteConfig = {
  path: 'clazz-details-for-student-code',
  name: 'clazz_details_for_student_code',
  component: ClazzDetailsForStudentCode,
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: Number(route.query.clazzId),
  }),
  meta: {
    title: '学生认证管理',
  },
}

export const studentMatchesInfoRoute: RouteConfig = {
  path: 'student-matches-info',
  name: 'student_matches_info',
  component: StudentMatchesInfo,
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: Number(route.query.clazzId),
  }),
  meta: {
    title: '关联详情',
    showMenu: false,
  },
}

export const studentDetailsRoute: RouteConfig = {
  path: 'student-details',
  name: 'student_details',
  component: StudentDetails,
  props: (route) => ({
    ...route.query,
    ...route.params,
    student: route.query.student ? JSON.parse(route.query.student as string) : null,
  }),
  meta: {
    title: '学生管理',
  },
}
export const studentDetailsSchoolRollNoRoute: RouteConfig = {
  path: 'student-details-roll-no',
  name: 'student_details_roll_no',
  component: StudentDetailsSchoolRollNo,
  props: (route) => ({
    ...route.query,
    ...route.params,
    student: route.query.student ? JSON.parse(route.query.student as string) : null,
  }),
  meta: {
    title: '学生认证管理',
  },
}

export const studentDetailsForSchoolAccountRoute: RouteConfig = {
  path: 'student-details-school-account',
  name: 'student_details_school_account',
  component: StudentDetailsForSchoolAccount,
  props: (route) => ({
    ...route.query,
    ...route.params,
    student: route.query.student ? JSON.parse(route.query.student as string) : null,
  }),
  meta: {
    title: '合作账号管理',
  },
}

export const TeacherListRoute: RouteConfig = {
  path: 'teacher-list',
  name: 'teacher_list',
  component: TeacherList,
  meta: {
    title: '教师管理',
    showMenu: true,
    roles: ['admin'],
  },
}

export const TeacherCreateRoute: RouteConfig = {
  path: 'teacher-create',
  name: 'teacher_create',
  component: TeacherCreate,
  meta: {
    title: '教师管理',
    showMenu: false,
    roles: ['admin'],
  },
}

export const TeacherDetailRoute: RouteConfig = {
  path: 'teacher-detail',
  name: 'teacher_detail',
  component: TeacherDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '教师管理',
    showMenu: false,
    roles: ['admin'],
  },
}
import schoolMenuIcon from '@/assets/images/icon_menu_school@2x.png'
import schoolMenuIconActive from '@/assets/images/icon_menu_school_active@2x.png'

export default [
  {
    path: '/school',
    name: 'school',
    component: Layout,
    meta: {
      title: '我的学校',
      icon: schoolMenuIcon,
      iconActive: schoolMenuIconActive,
      showMenu: true,
    },
    children: [
      schoolManageRoute,
      TeacherListRoute,
      TeacherCreateRoute,
      TeacherDetailRoute,
      gradeListRoute,
      clazzListRoute,
      studentListRoute,
      studentAuthRoute,
      studentAuthAccountRoute,
      studentAuthAccountDetailRoute,

      gradeDetailsRoute,
      clazzDetailsRoute,
      clazzDetailsForStudentCodeRoute,
      studentDetailsRoute,
      studentDetailsSchoolRollNoRoute,
      studentDetailsForSchoolAccountRoute,
      studentMatchesInfoRoute,
    ],
  },
]

export function navigateToWebTeacherList(router: VueRouter) {
  router.push({ name: TeacherListRoute.name })
}

export function navigateToGradeDetails(router: VueRouter, gradeId: number) {
  router.push({ name: gradeDetailsRoute.name, query: { gradeId: String(gradeId) } })
}

export function navigateToClazzDetails(router: VueRouter, clazzId: number, clazzName?: string) {
  router.push({ name: clazzDetailsRoute.name, query: { clazzId: String(clazzId), clazzName } })
}

export function navigateToClazzStudentAccountDetails(router: VueRouter, clazzId: number, clazzName?: string) {
  router.push({ name: studentAuthAccountDetailRoute.name, query: { clazzId: String(clazzId), clazzName } })
}

export function navigateToClazzDetailsForStudentCode(router: VueRouter, clazzId: number, clazzName?: string) {
  router.push({ name: clazzDetailsForStudentCodeRoute.name, query: { clazzId: String(clazzId), clazzName } })
}

export function navigateToStudentMatchesInfo(router: VueRouter, clazzId: number) {
  router.push({
    name: studentMatchesInfoRoute.name,
    query: {
      clazzId: String(clazzId),
    },
  })
}

export function navigateToStudentDetails(router: VueRouter, student: Student) {
  router.push({ name: studentDetailsRoute.name, query: { student: JSON.stringify(student) } })
}

export function navigateToStudentDetailsSchoolRollNo(router: VueRouter, student: IStudentTableItemForStudentCode) {
  router.push({ name: studentDetailsSchoolRollNoRoute.name, query: { student: JSON.stringify(student) } })
}

export function navigateToStudentDetailsSchoolAccount(router: VueRouter, student: IStudentTableItemForStudentCode) {
  router.push({ name: studentDetailsForSchoolAccountRoute.name, query: { student: JSON.stringify(student) } })
}

export function navigateToTeacherDetails(router: VueRouter) {
  router.push({
    name: TeacherDetailRoute.name,
  })
}

export function navigateToTeacherCreate(router: VueRouter) {
  router.push({ name: TeacherCreateRoute.name })
}
